

































































import { SbpDefaultModalVue } from "fs-pb-vue2/vueModels/settings/SbpDefaultModalVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox }
})
export default class SbpDefaultModal extends SbpDefaultModalVue {
  async mounted() {
    await this.init();
  }
}
